import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiClient } from '@/lib/apiClient'
import { API_ROUTES, PAGINATION } from '@/constants/apiRoutes'
import { NotificationHistoryAction, NotificationHistoryList } from '@/types/index'

export const getNotificationHistory = createAsyncThunk<NotificationHistoryList, { certIds: string[], userIds: string[], status: string[], noticeDateEnd: string, noticeDateStart: string, page: number, pageSize: number }>(API_ROUTES.NOTIFICATION_HISTORY_GET, async ({ certIds, userIds, status, noticeDateStart, noticeDateEnd, page, pageSize }) => {
  const res = await apiClient.post<NotificationHistoryList>(API_ROUTES.NOTIFICATION_HISTORY_GET, {
    cert_ids: certIds,
    user_ids: userIds,
    status: status,
    notice_date_start: noticeDateStart,
    notice_date_end: noticeDateEnd,
    page: page,
    page_size: pageSize,
  },
  )
  return res
})
export const resendNotificationHistory = createAsyncThunk<NotificationHistoryAction, { certIds: string[], userIds: string[], imageIds: number[], noticeDateEnd: string | null, noticeDateStart: string | null, status: string[] }>(API_ROUTES.NOTIFICATION_HISTORY_RESEND, async ({ certIds, userIds, status, noticeDateStart, noticeDateEnd, imageIds }) => {
  const res = await apiClient.put<NotificationHistoryAction>(API_ROUTES.NOTIFICATION_HISTORY_RESEND, {
    cert_ids: certIds,
    user_ids: userIds,
    status: status,
    notice_date_start: noticeDateStart,
    notice_date_end: noticeDateEnd,
    image_ids: imageIds
  },
  )
  return res
})
export const cancelNotificationHistory = createAsyncThunk<NotificationHistoryAction, { certIds: string[], userIds: string[], imageIds: number[], noticeDateEnd: string | null, noticeDateStart: string | null, status: string[] }>(API_ROUTES.NOTIFICATION_HISTORY_CANCEL, async ({ certIds, userIds, status, noticeDateStart, noticeDateEnd, imageIds }) => {
  const res = await apiClient.put<NotificationHistoryAction>(API_ROUTES.NOTIFICATION_HISTORY_CANCEL, {
    cert_ids: certIds,
    user_ids: userIds,
    status: status,
    notice_date_start: noticeDateStart,
    notice_date_end: noticeDateEnd,
    image_ids: imageIds
  },
  )
  return res
})

const initialState: NotificationHistoryList = {
  items: [],
  message: '',
  page: PAGINATION.PAGE,
  page_size: PAGINATION.PAGE_SIZE,
  status: '',
  total: 0,
  loading: false,
  error: null
}

const notificationHistorySlice = createSlice({
  name: 'notificationHistory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET
      .addCase(getNotificationHistory.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getNotificationHistory.fulfilled, (state, action) => {
        state.items = action.payload.items
        state.message = action.payload.message
        state.page = action.payload.page
        state.page_size = action.payload.page_size
        state.status = action.payload.status
        state.total = action.payload.total
        state.loading = false
      })
      .addCase(getNotificationHistory.rejected, (state, action) => {
        state.error = action.error.message || 'Error'
        state.loading = false
      })
      // RESEND
      .addCase(resendNotificationHistory.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(resendNotificationHistory.fulfilled, (state, action) => {
        state.message = action.payload.message
        state.status = action.payload.status
        state.loading = false
      })
      .addCase(resendNotificationHistory.rejected, (state, action) => {
        state.error = action.error.message || 'Error'
        state.loading = false
      })
      // CANCEL
      .addCase(cancelNotificationHistory.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(cancelNotificationHistory.fulfilled, (state, action) => {
        state.message = action.payload.message
        state.status = action.payload.status
        state.loading = false
      })
      .addCase(cancelNotificationHistory.rejected, (state, action) => {
        state.error = action.error.message || 'Error'
        state.loading = false
      })
  },
})

export default notificationHistorySlice.reducer
